/* src/app/main/links/links.component.scss */
.links p {
  font-family:
    Arial,
    Helvetica,
    sans-serif;
  font-size: medium;
}
/*# sourceMappingURL=links.component.css.map */
